import styled, { css } from "styled-components";
import { buttonSpacing } from "../utils";
export const StyledButton = styled.button `
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  ${({ rounded }) => (rounded ? "border-radius: 50%" : "")};
  background-color: ${({ stylingType }) => stylingType.background};
  color: ${({ stylingType }) => stylingType.color};
  border: 1px solid ${({ stylingType }) => stylingType.border};
  box-sizing: border-box;
  white-space: nowrap;
  min-width: unset;

  ${({ size, stylingType }) => `
    height: ${buttonSpacing(size, stylingType.type).height}px;
  `}

  span.icon, span.no-icon {
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ size, stylingType }) => `
      width: ${buttonSpacing(size, stylingType.type).height}px !important;
      height: ${buttonSpacing(size, stylingType.type).height}px;
    `}
  }

  svg {
    fill: ${({ stylingType }) => stylingType.color};

    ${({ size, stylingType }) => `
      width: ${buttonSpacing(size, stylingType.type).height -
    buttonSpacing(size, stylingType.type).iconSpacing * 2}px;
    `};
  }

  @media (hover: hover) {
    &:hover {
      ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.color)
        ? `color: ${stylingType.hover.color};`
        : "";
}};

      ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.background)
        ? `background-color: ${stylingType.hover.background};`
        : "";
}};

      ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.border)
        ? `border: 1px solid ${stylingType.hover.border};`
        : "";
}};

      svg {
        ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.color)
        ? `fill: ${stylingType.hover.color};`
        : "";
}};
      }
    }
  }

  &:focus {
    ${({ stylingType, focused }) => {
    var _a;
    return ((_a = stylingType.focus) === null || _a === void 0 ? void 0 : _a.border) && focused
        ? `border: 1px solid ${stylingType.focus.border};`
        : "";
}};

    ${({ stylingType, focused, rounded }) => {
    var _a;
    return ((_a = stylingType.focus) === null || _a === void 0 ? void 0 : _a.border) && focused
        ? !rounded
            ? `outline: 1px solid ${stylingType.focus.border};`
            : `outline: none; box-shadow: 0 0 0 1px ${stylingType.focus.border}; border-radius: 50%;`
        : "outline: none;";
}};
  }

  &::-moz-focus-inner {
    border: 0;
  }

  ${({ stylingType, selected }) => {
    var _a;
    return selected && ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.color)
        ? `color: ${stylingType.active.color}`
        : "";
}};

  ${({ stylingType, selected }) => {
    var _a;
    return selected && ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.background)
        ? `background-color: ${stylingType.active.background};`
        : "";
}};

  ${({ stylingType, selected }) => {
    var _a;
    return selected && ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.border)
        ? `border: 1px solid ${stylingType.active.border};`
        : "";
}};

  svg {
    fill: ${({ theme, stylingType, selected }) => selected
    ? stylingType.type !== "flatInverted"
        ? theme.colors.white
        : stylingType.active.color
    : ""};
  }

  &:active {
    outline: none;
    ${({ theme }) => theme.global.disableTapHighlight};

    ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.color) && active
        ? `color: ${stylingType.active.color}`
        : "";
}};

    ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.background) && active
        ? `background-color: ${stylingType.active.background};`
        : "";
}};

    ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.border) && active
        ? `border: 1px solid ${stylingType.active.border};`
        : "";
}};

    svg {
      ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.color) && active
        ? `fill: ${stylingType.active.color}`
        : "";
}};
    }
  }

  &:disabled {
    cursor: default;
    ${({ stylingType }) => {
    var _a;
    return ((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.color)
        ? `color: ${stylingType.disabled.color}`
        : "";
}};

    ${({ stylingType }) => {
    var _a;
    return ((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.background)
        ? `background-color: ${stylingType.disabled.background};`
        : "background-color: transparent";
}};

    border: ${({ stylingType }) => {
    var _a;
    return `1px solid ${((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.border)
        ? stylingType.disabled.border
        : stylingType.border};`;
}};

    svg {
      ${({ stylingType }) => {
    var _a;
    return ((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.color)
        ? `fill: ${stylingType.disabled.color};`
        : "";
}};
    }
  }

  ${({ isIcon, stretched, size, stylingType, symbol }) => {
    if (isIcon) {
        return `width: ${buttonSpacing(size, stylingType.type).height}px;`;
    }
    if (stretched) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        if (symbol) {
            return `min-width: 3.75rem;`;
        }
        return `min-width: 2.5rem;`;
    }
    return `min-width: 6.25rem;`;
}}

  ${({ size, theme }) => {
    if (size === "huge") {
        return `
        font-size: ${theme.fontTokens.font09[0]};
        line-height: ${theme.fontTokens.font09[1]};
      `;
    }
    else {
        return `
        font-size: ${theme.fontTokens.font11[0]};
        line-height: ${theme.fontTokens.font11[1]};
      `;
    }
}};

  span.icon {
    ${({ hasChildren, symbol, stylingType }) => hasChildren && symbol
    ? `
          width: ${buttonSpacing("tiny", stylingType.type).height}px;
          display: flex; justify-content: center;
        `
    : ""};
  }

  ${({ isIcon, hasChildren, symbol, iconAlignment, size, stylingType, alignByContent, }) => {
    if (isIcon)
        return "padding: 0;";
    if (hasChildren && symbol) {
        return `
        padding: 0 ${iconAlignment === "left"
            ? `${buttonSpacing(size, stylingType.type).paddingRight}px`
            : 0} 0 ${iconAlignment === "right"
            ? `${buttonSpacing(size, stylingType.type).paddingRight}px`
            : 0};

      ${alignByContent === "left"
            ? "transform: translate(-1rem);"
            : alignByContent === "right"
                ? "transform: translate(1rem);"
                : ""}
      `;
    }
    return `
      padding: 0 ${buttonSpacing(size, stylingType.type).padding}px;

      ${alignByContent === "left"
        ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
            ? "-1.5rem"
            : "-1rem"});`
        : alignByContent === "right"
            ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
                ? "1.5rem"
                : "1rem"});`
            : ""}
    `;
}};

  ${({ size, stylingType, hasChildren, symbol, iconAlignment, isIcon }) => size === "standard" &&
    css `
      @media ${({ theme }) => theme.device.touch} and (orientation: landscape) {
        ${({ theme }) => `
        font-size: ${theme.fontTokens.font11[0]};
        line-height: ${theme.fontTokens.font11[1]};`}

        height: ${buttonSpacing("touch", stylingType.type).height}px !important;
        span {
          width: ${buttonSpacing("touch", stylingType.type).height}px !important;
          height: ${buttonSpacing("touch", stylingType.type).height}px !important;

          svg {
            width: ${buttonSpacing("touch", stylingType.type).height -
        buttonSpacing("touch", stylingType.type).iconSpacing * 2}px;
          }
        }

        ${() => {
        if (hasChildren && symbol) {
            return `
              padding: 0 ${iconAlignment === "left"
                ? `${buttonSpacing("touch", stylingType.type).paddingRight}px`
                : 0} 0 ${iconAlignment === "right"
                ? `${buttonSpacing("touch", stylingType.type).paddingRight}px`
                : 0}`;
        }
        if (isIcon) {
            return `width: ${buttonSpacing("touch", stylingType.type).height}px !important;`;
        }
    }}
    `}
`;
